


const APP_STRIPE_INFO_URI = '/p/api/stripe/props';
const APP_STRIPE_SESSION_URI = '/p/api/stripe/session';
const APP_STRIPE_INTENT = '/api/stripe/payment-intent';
export const PayStripeApi = {

    async getStripeInfo(){
        const response = await axios.get(`${APP_STRIPE_INFO_URI}`);
        return response.data;
    },
    async getStripeSession(){
        const response = await axios.get(`${APP_STRIPE_SESSION_URI}`);
        return response.data;
    },
    async getIntent(obj){
        const  paramsString = new URLSearchParams(obj).toString();
        const response = await axios.get(`${APP_STRIPE_INTENT}?`+paramsString);
        return response.data;
    },
    async payed(intent, locationId){
        const response = await axios.post(`/api/stripe/payed?locationId=`+locationId,intent);
        return response.data;
    }
};
